<template>
  <div class="col-sm">
    <div class="company">
      <div class="company__titleBar">
        <h3 class="h5 company__title">
          <router-link :to="{name: 'CompanyDetail', params:{alias: company.alias} }">
            <a href="#">{{company.name}}</a>
          </router-link>
        </h3>

        <div class="company__location">
          <i class="icomoon icon-map-pin" aria-hidden="true"></i>
          {{company.city}}, {{company.province}}
        </div>
      </div>
      <span v-if="company.logoId">
        <img class="company__image_listing" :src="`${apiUrl}api/v1/file/${company.logoId}`" alt />
      </span>
      <span v-else>
        <img class="company__image_listing" src="img/placeholder.svg"/>
      </span>

      <p class="company__description">{{company.description}}<span v-if="company.viewMoreDescription">
        <router-link :to="{name: 'CompanyDetail', params:{alias: company.alias} }">
          <a style="font-size: 0.90rem;" href="#">...View More</a>
          </router-link>
          </span>
      </p>

      <div class="company__certs">
        <p>
          <strong>Certifications:</strong>
        </p>
        <ul class="list-reset">        
         
          <li v-if="company.wcbCertified">
            <img class="company__certs__image" src="/img/wcb.jpg" width="20" height="20" alt />
          </li>
          <li v-if="company.corCertified">
            <img class="company__certs__image" src="/img/cor-seal.png" width="20" height="20" alt />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Company",

  data() {
    return {
      apiUrl: process.env.VUE_APP_API_URL
    };
  },
  props: {
    company: {
      type: Object,
      default: () => {}
    }
  }
};
</script>